const reducer = (state = '', action) =>{
    switch(action.type){
        case "setCompanyProfileSearch": 
            return action.payload;
        default: 
            return state;
    }
}

export default reducer;  